export default "__VITE_ASSET__D9uzACE5__"